import React, { useState, useEffect } from 'react';
import Modal from '../../common/Modal';
import Button from '../../common/Button';
import { useToast } from '../../../context/ToastContext';
import userService from '../../../api/services/userService';
import hostService from '../../../api/services/hostService';
import { handleApiError } from '../../../utils/helpers';
// import Modal from '../common/Modal';
// import Button from '../common/Button';
// import { useToast } from '../../context/ToastContext';
// import userService from '../../api/services/userService';
// import hostService from '../../api/services/hostService';
// import { handleApiError } from '../../utils/helpers';

const TransferHostModal = ({ host, onClose, onSuccess }) => {
  const { success, error } = useToast();
  const [loading, setLoading] = useState(false);
  const [companyAdmins, setCompanyAdmins] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState('');

  useEffect(() => {
    fetchCompanyAdmins();
  }, []);

  const fetchCompanyAdmins = async () => {
    try {
      const response = await userService.getAllUsers({ role: 'COMPANY_ADMIN', pageSize: 100 });
      const users = response.data?.users || response.data || [];
      
      // Filter out the current owner
      const availableAdmins = users.filter(user => 
        user.id !== host.userId && user.isApproved
      );
      
      setCompanyAdmins(availableAdmins);
    } catch (err) {
      error(handleApiError(err));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedUserId) {
      error('Please select a user to transfer to');
      return;
    }

    if (!window.confirm(
      `Are you sure you want to transfer "${host.name}" to the selected Company Admin? This will transfer all contests, categories, and contestants under this host.`
    )) {
      return;
    }

    try {
      setLoading(true);
      await hostService.transferHostOwnership(host.id, selectedUserId);
      success('Host ownership transferred successfully');
      onSuccess();
    } catch (err) {
      error(handleApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title={`Transfer "${host.name}"`}
      size="md"
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Current Owner Info */}
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
          <h4 className="text-sm font-medium text-gray-700 mb-2">Current Owner</h4>
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center">
              <span className="text-primary-600 font-medium text-sm">
                {host.user?.firstName?.[0]}{host.user?.lastName?.[0]}
              </span>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900">
                {host.user?.firstName} {host.user?.lastName}
              </p>
              <p className="text-xs text-gray-500">{host.user?.email}</p>
            </div>
          </div>
        </div>

        {/* Select New Owner */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Transfer to Company Admin *
          </label>
          {companyAdmins.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg border border-gray-200">
              <svg
                className="mx-auto h-12 w-12 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                />
              </svg>
              <p className="mt-2 text-sm text-gray-600">
                No available Company Admins found
              </p>
            </div>
          ) : (
            <select
              value={selectedUserId}
              onChange={(e) => setSelectedUserId(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              required
            >
              <option value="">Choose a Company Admin...</option>
              {companyAdmins.map(user => (
                <option key={user.id} value={user.id}>
                  {user.firstName} {user.lastName} ({user.email})
                </option>
              ))}
            </select>
          )}
        </div>

        {/* Warning Message */}
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
          <div className="flex">
            <svg
              className="h-5 w-5 text-yellow-400 mr-3 flex-shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
            <div>
              <h4 className="text-sm font-medium text-yellow-800 mb-1">
                Transfer Warning
              </h4>
              <p className="text-xs text-yellow-700">
                This will transfer the host and all its contests, categories, and contestants
                to the selected Company Admin. This action cannot be undone.
              </p>
            </div>
          </div>
        </div>

        {/* Transfer Summary */}
        {host._count && (
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h4 className="text-sm font-medium text-blue-900 mb-2">
              What will be transferred:
            </h4>
            <ul className="space-y-1 text-sm text-blue-800">
              <li className="flex items-center">
                <svg className="w-4 h-4 mr-2 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                Host: {host.name}
              </li>
              <li className="flex items-center">
                <svg className="w-4 h-4 mr-2 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                {host._count.contests || 0} Contest(s)
              </li>
              <li className="flex items-center">
                <svg className="w-4 h-4 mr-2 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                All categories and contestants
              </li>
            </ul>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex justify-end gap-3 pt-4 border-t">
          <Button
            type="button"
            variant="secondary"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loading={loading}
            disabled={companyAdmins.length === 0}
          >
            Transfer Host
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default TransferHostModal;